import {gql} from "@irati/utils/gql"
import getQueryNames from "@irati/utils/services/apollo/helpers/getQueryNames"

const query = gql`
  mutation DeleteSavedCardForProvider($provider: PaymentProvider!, $cardReference: ID!) {
    deleteSavedCard(provider: $provider, cardReference: $cardReference)
  }
`

export const toString = query.loc.source.body

export const deleteSavedCardKey = getQueryNames(query)[0]

export default query
